import { Component, OnDestroy, OnInit } from "@angular/core";
import { ModalController, Platform } from "@ionic/angular";
import { CrudService } from "../../services/crud.service";
import { Browser } from "@capacitor/browser";
import { Capacitor } from "@capacitor/core";
import { Router } from "@angular/router";
import { Events } from "../../services/events-service.service";
import { AuthService } from "../../services/auth.service";
import { UserType } from "src/models/user.model";

@Component({
    selector: "app-payment-complete",
    templateUrl: "./payment-complete.component.html",
    styleUrls: ["./payment-complete.component.scss"],
    standalone: false
})
export class PaymentCompleteComponent implements OnInit, OnDestroy {
  downloadInvoice() {
    const sessionId = sessionStorage.getItem("sessionId");
    this.crudService
      .getData(`pagamento/stripe-receipt/session/${sessionId}`)
      .subscribe((res: string) => {
        if (Capacitor.isNativePlatform()) {
          Browser.open({ url: res, windowName: "_system" }).catch(console.error);
          return;
        }
        window.open(res, "_blank");
      });
  }
  async dismiss() {
    if (this.authService.user.userType === UserType.Driver) {
      await this.router.navigate(["/driver/queue"]);
    } else {
      await this.router.navigate(["/call/reservations-requests"]);
    }
    await this.modalCtrl.dismiss(null, "cancel");
  }

  constructor(
    private modalCtrl: ModalController,
    private crudService: CrudService,
    private platform: Platform,
    private router: Router,
    private events: Events,
    private authService: AuthService
  ) {}
  ngOnDestroy(): void {
    this.events.publish("getBalance");
  }

  ngOnInit() {
    this.crudService
      .postData("pagamento/realizar-pagamento-stripe", "", { tipoPagamento: 0 })
      .subscribe();
  }
}
